// Libraries
import { Controller } from '@hotwired/stimulus';

// Utilities
import apiFetch from '../utils/api-fetch';

/* stimulusFetch: 'lazy' */

/**
 * @class LogController
 * @extends Controller
 * @description Submits a user action to the registration log.
 */
class LogController extends Controller {
    /**
     * @method logAction
     * @description Log the action and report on the outcome.
     *
     * @async
     * @param {Event} event - The event object
     * @return {void}
     */
    async logAction(event) {
        const endpoint = '/api/reg';
        const method = 'POST';
        const action = event.type;
        const url = location.href;
        const data = { action: action, ...event.params, url: url };
        const response = await apiFetch(endpoint, method, data, 'json');

        if (!response.error) {
            console.log(response);
        }
    }
}

// Exports
export default LogController;
